import { useMutation, useQuery } from 'react-query';

import { PRODUCTS_QUERY_KEY } from '~/api/query-keys';
import { productsRepository } from '~/api/repository/products';

export type { EstimateProductPaymentRequest } from '~/api/data-source/products';
export type {
  EstimateProductPayment,
  MarketProductDetail,
  MarketSelectProduct,
  ProductOptionList,
  RecentlyViewedProduct,
} from '~/api/model';

/** 유사 상품 목록 조회 */
// GET /api/market-place/v1/similar/products
export const useSimilarProducts = (offerId: number) => {
  const { queryKey, queryFn } = PRODUCTS_QUERY_KEY.similar(offerId);

  return useQuery(queryKey, queryFn, {
    enabled: !!offerId,
    keepPreviousData: true,
  });
};

/** 함께 구매하는 상품(교차판매) 목록 조회 */
// GET /api/market-place/v1/cross-sell/{offerId}/products
export const useCrossSellProducts = (offerId: number, enabled = false) => {
  const { queryKey, queryFn } = PRODUCTS_QUERY_KEY.crossSell(offerId);

  return useQuery(queryKey, queryFn, {
    enabled: enabled && !!offerId,
  });
};

/** 최근 본 상품 목록 조회 */
// GET /api/market-place/v1/products/recently-viewed-products
export const useRecentlyViewedProducts = () => {
  const { queryKey, queryFn } = PRODUCTS_QUERY_KEY.recentlyViewed();

  return useQuery(queryKey, queryFn, {
    keepPreviousData: true,
  });
};

/** 상품 상세 조회 */
// GET /api/market-place/v2/products/{offerId}/details
export const useMarketProductDetail = (offerId: number) => {
  const { queryKey, queryFn } = PRODUCTS_QUERY_KEY.detail(offerId);

  return useQuery(queryKey, queryFn, {
    enabled: !!offerId,
  });
};

/** 상품 옵션 목록 조회 */
// GET /api/market-place/v2/products/{offerId}/options
export const useProductOptions = (offerId: number) => {
  const { queryKey, queryFn } = PRODUCTS_QUERY_KEY.options(offerId);

  return useQuery(queryKey, queryFn, {
    enabled: !!offerId,
    retry: 2,
  });
};

/** 상품 결제 예상 금액 계산 */
// POST /api/market-place/v2/products/estimate-product-payment
export const useEstimateProductPayment = () => {
  return useMutation({
    mutationFn:
      productsRepository.estimateProductPayment.bind(productsRepository),
  });
};
